import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"

// ページ遷移時は常にトップへスクロールする（ブラウザ標準の位置復元による
// 「中途半端な位置で表示される」挙動を防ぐ）
export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  // ハッシュリンク（#xxx）の場合は該当位置へ、それ以外はトップへ
  if (!location.hash) {
    window.scrollTo(0, 0)
  }
  return false
}
